<template>
  <div class="shape-menu-component">
    <div class="menu-section">
      <p class="section-title">形状</p>
      <ul class="shape-list">
        <li
          v-for="shape in shapes"
          :key="shape.type"
          :class="{ active: selectedShape === shape.type }"
          @click="handleShapeSelect(shape.type)"
          :tabindex="0"
          :aria-label="shape.label"
        >
          <el-tooltip
            popper-class="live-room-tooltip"
            effect="dark"
            :content="shape.label"
            placement="top"
            :disabled="isHXApp"
          >
            <span class="shape-icon">
              <img
                :src="require('../../assets/images/' + shape.type + '.png')"
                alt=""
              />
            </span>
          </el-tooltip>
        </li>
      </ul>
    </div>
    <div class="menu-section">
      <p class="section-title">粗细</p>
      <ul class="thickness-list">
        <li
          v-for="thick in thicknesses"
          :key="thick"
          :class="{ active: selectedThickness === thick }"
          @click="handleThicknessSelect(thick)"
          :tabindex="0"
          :aria-label="'粗细' + thick"
        >
          <img
            class="size-dot"
            :src="require('../../assets/images/size' + thick + '.png')"
            alt=""
          />
        </li>
      </ul>
    </div>
    <div class="menu-section">
      <p class="section-title">形状颜色</p>
      <ul class="color-list">
        <li
          v-for="color in penColors"
          :key="color"
          :class="{ active: selectedColor === color }"
          @click="handleColorSelect(color)"
          :tabindex="0"
          :aria-label="'颜色' + color"
        >
          <div class="color-dot" :style="{ backgroundColor: color }">
            <span v-if="selectedColor === color" class="color-selected"></span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ShapeMenu",
  data() {
    return {
      shapes: [
        { type: "rect", label: "矩形" },
        { type: "circle", label: "圆" },
        { type: "triangle", label: "三角形" },
        { type: "line", label: "直线" },
        { type: "arrow", label: "箭头" },
      ],
      thicknesses: [50, 75, 100],
      penColors: [
        "#000000",
        "#E2584F",
        "#F6C847",
        "#65C445",
        "#456FF6",
        "#7640EC",
      ],
      selectedShape: "rect",
      selectedThickness: 75,
      selectedColor: "#000000",
    };
  },
  computed: {
    ...mapState("live", ["whiteBoardService", "isHXApp"]),
  },
  methods: {
    handleShapeSelect(type) {
      this.selectedShape = type;
      this.handleStyleChange();
    },
    handleThicknessSelect(thick) {
      this.selectedThickness = thick;
      this.handleStyleChange();
    },
    handleColorSelect(color) {
      this.selectedColor = color;
      this.handleStyleChange();
    },
    handleStyleChange() {
      this.whiteBoardService.setShapeStyle({
        shapeType: this.selectedShape,
        lineWidth: this.selectedThickness,
        color: this.selectedColor,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.shape-menu-component {
  width: 167px;
  background: #fff;
  box-shadow: 0px 4px 10px 0px rgba(20, 20, 43, 0.04);
  border-radius: 10px;
  border: 1px solid $live-room-border-color;
  padding: 0 12px;

  .menu-section {
    padding: 12px 0 4px;
    border-bottom: 1px solid $live-room-border-color;
    &:last-child {
      border: none;
    }
  }
  .section-title {
    font-weight: 500;
    font-size: 12px;
    color: #4e5969;
    line-height: 20px;
    margin-bottom: 4px;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      margin-right: 24px;
      &:nth-child(3n) {
        margin-right: 0;
      }
      margin-top: 8px;
      margin-bottom: 8px;
      outline: none;
    }
  }
  .shape-list {
    li {
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;
      &:hover,
      &:focus {
        background: $live-room-hover-bg;
      }
      &.active {
        background: $live-room-active-bg;
      }
      .shape-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
  .thickness-list {
    li {
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.3s;
      &:hover,
      &:focus {
        background: $live-room-hover-bg;
      }
      &.active {
        background: $live-room-active-bg;
      }
      .size-dot {
        width: 20px;
        height: 20px;
      }
    }
  }
  .color-list {
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      width: 28px;
      height: 28px;
      .color-dot {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      &.active::after,
      &:hover::after {
        display: block;
        content: "";
        width: 12px;
        height: 12px;
        border-radius: 50%;
        border: 2px solid #ffffff;
        background: transparent;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
</style>
